var _rect, _path, _circle, _circle2, _rect2, _rect3, _text, _rect4, _text2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _text3, _text4, _text5, _path2, _path3, _path4, _rect12, _rect13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 146,
    r: 235,
    fill: "#2DD4BF",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 618,
    r: 260,
    fill: "#F59E0B",
    opacity: 0.17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 120,
    width: 944,
    height: 520,
    rx: 34,
    fill: "#191B20",
    stroke: "rgba(255,255,255,.14)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 172,
    width: 218,
    height: 54,
    rx: 14,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 207,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 27,
    fontWeight: 900
  }, "QuoteFlow")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 270,
    width: 332,
    height: 248,
    rx: 24,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.13)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 322,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "Quote Builder")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 354,
    width: 238,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 394,
    width: 202,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 434,
    width: 256,
    height: 16,
    rx: 8,
    fill: "#94A3B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 474,
    width: 126,
    height: 24,
    rx: 12,
    fill: "#2DD4BF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 270,
    width: 202,
    height: 116,
    rx: 22,
    fill: "rgba(45,212,191,.13)",
    stroke: "rgba(45,212,191,.42)",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 270,
    width: 202,
    height: 116,
    rx: 22,
    fill: "rgba(245,158,11,.12)",
    stroke: "rgba(245,158,11,.38)",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 426,
    width: 442,
    height: 92,
    rx: 22,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.13)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 586,
    y: 321,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 23,
    fontWeight: 900
  }, "Requests")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 321,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 23,
    fontWeight: 900
  }, "Payments")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 586,
    y: 478,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 23,
    fontWeight: 900
  }, "Supplier analytics dashboard")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605 344h112",
    stroke: "#2DD4BF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M845 344h112",
    stroke: "#F59E0B",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M586 500h300",
    stroke: "#94A3B8",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 560,
    width: 824,
    height: 18,
    rx: 9,
    fill: "rgba(255,255,255,.12)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 560,
    width: 674,
    height: 18,
    rx: 9,
    fill: "#2DD4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteflow);
export default __webpack_public_path__ + "static/media/quoteflow.43efc238d335ca15e1746f88c8cea56c.svg";
export { ForwardRef as ReactComponent };